import { mapDataCloudfrontURL } from "../map/MapConstants";
import { getZippedGeoJson } from "../map/ZippedGeoJsonReader";
import { Source, Layer } from "react-map-gl";
import { useState, useEffect } from "react";
import { emptyGeojson } from "../riskAssessment/defaultSourceLayer";

export const DetectedMinesLayer: React.FC<{
  active: boolean;
}> = ({ active }) => {
  const [geoJsonData, setGeoJsonData] = useState<GeoJsonData>(emptyGeojson);

  const getDetectedMinesMap = async (): Promise<GeoJsonData> => {
    const url = `${mapDataCloudfrontURL}mining/cys_data_minex_wrl_pangea_poly/cys_data_minex_bra_pangea_poly.zip`;
    return getZippedGeoJson(url);
  };

  useEffect(() => {
    if (active) {
      getDetectedMinesMap().then((geoJsonRes: GeoJsonData) => {
        setGeoJsonData(geoJsonRes);
      });
    } else {
      setGeoJsonData(emptyGeojson);
    }
  }, [active]);

  return (
    <Source key="detectedMine" id="detectedMine-src" type="geojson" data={geoJsonData}>
      <Layer
        type="fill"
        paint={{
          "fill-color": "brown",
          "fill-opacity": 0.8,
        }}
        source="detectedMine-src"
        id="detectedMine-layer"
      />
    </Source>
  );
};
